import { useEffect } from "react";

import useNoteStore from "@store/useNoteStore";
import useSideBladeStore from "@store/useSideBladeStore";
import { useGetBoundNote } from "./hooks/useGetBoundNote";
import { useGetBoundNotes } from "./hooks/useGetBoundNotes";
import { useUpdateNote } from "./hooks/useUpdateNote";
import { RelationObjectType } from "@enums/relations.enum";
import { AINote } from "@app-types/notes.type";
import NotesScreen from "@screens/notes";
import { SectionHeading } from "@ui/Headings";
import { NoteEditor } from "./NoteEditor";
import { Counter } from "@ui/Counter";
import { View } from "@ui/View";

interface Props {
  objectId: string; // Holds either threadId for emails or meetingId for meeting
  contentType: RelationObjectType;
}

export function NoteSection({ objectId, contentType }: Props) {
  const { openSideBlade, closeSideBlade } = useSideBladeStore();
  const { setActiveNoteId } = useNoteStore();
  const { data: note } = useGetBoundNote(objectId, contentType);
  const { data: notes } = useGetBoundNotes(objectId, contentType, !!note?.id);
  const { mutateAsync: updateNoteMutate } = useUpdateNote(objectId, contentType);

  const handleUpdateNote = (data: Partial<AINote>) => {
    updateNoteMutate({ noteId: note?.id || "", data });
  };

  const handleOpenNoteList = () => {
    openSideBlade(<NotesScreen notes={notes?.results || []} onGoBack={closeSideBlade} />);
  };

  useEffect(() => {
    if (typeof note === "undefined") return;

    note?.id && setActiveNoteId(note.id);
  }, [note]);

  return (
    <section className="flex flex-col gap-2 rounded-xl">
      <header className="flex gap-[10px] justify-between items-center">
        <SectionHeading>My notes</SectionHeading>

        <View.Condition if={Boolean(notes?.count)}>
          <div className="flex gap-[10px] items-center text-gray-450 dark:text-white">
            <span className="cursor-pointer" onClick={handleOpenNoteList}>
              Team member notes
            </span>
            <Counter value={notes?.count || 0}></Counter>
          </div>
        </View.Condition>
      </header>

      <NoteEditor note={note} onUpdateNote={handleUpdateNote} />
    </section>
  );
}
